import { useEffect, useState } from "react";

import { getClasses } from "../../utils";
import classes from "./SearchBar.module.css";
import searchIcon from "../../assets/icons/search.svg";

interface CommonProps {
  placeholder?: string;
  greyBackground?: boolean;
}

type ConditionalProps =
  | {
      debounce?: boolean;
      onChange: (text: string) => void;
      onSearch?: never;
    }
  | {
      onSearch: (text: string) => void;
      debounce?: never;
      onChange?: never;
    };

type Props = CommonProps & ConditionalProps;

const SearchBar: React.FC<Props> = ({
  debounce,
  placeholder,
  greyBackground,
  onChange,
  onSearch,
}) => {
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (onChange) {
      if (debounce) {
        const timeout = setTimeout(() => {
          onChange(searchText);
        }, 500);
        return () => clearTimeout(timeout);
      } else {
        onChange(searchText);
      }
    }
  }, [searchText]);

  return (
    <div
      className={getClasses(
        classes.searchBar,
        greyBackground ? classes.greyBackground : ""
      )}>
      <img
        src={searchIcon}
        alt='Search'
        onClick={() => onSearch && onSearch(searchText)}
      />
      <input
        type='text'
        placeholder={placeholder || "Search"}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onKeyUp={(e) => e.keyCode === 13 && onSearch && onSearch(searchText)}
      />
    </div>
  );
};

export default SearchBar;
